export default __webpack_public_path__ + "static/media/imgDelete.b1b78826.svg";